import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import AutocompleteComponent from '../../../components/filters/AutocompleteComponent'
import { GET_FACTORY_FILTER } from '../../../queries/factory'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'

export default function Factories (): JSX.Element {
  const { filters, setFilters } = useContext(FactoryFiltersContext)
  const { data } = useQuery(GET_FACTORY_FILTER)

  if (!data?.aggregation?.aggregations) return <p>No data found</p>

  const { factories: tempFactories } = data.aggregation.aggregations
  const factories: Array<string> = []

  tempFactories.buckets.map((factory: any) => {
    factories.push(factory.key)
  })

  const onChange = (value: string[]) => {
    setFilters({
      factory: value
    })
  }

  const typographLabel = 'Factories'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={factories}
        defaultValues={filters?.factory}
        onChange={onChange}
      />
    </Fragment>
  )
}
